import React from 'react';
import { motion } from 'framer-motion';
import { useAppContext } from '../context/AppContext';
export const Thanks = () => {
  const {
    userName
  } = useAppContext();
  const firstName = userName ? userName.split(' ')[0] : 'amigo/a';
  const shareLinkedIn = () => {
    window.open('https://www.linkedin.com/sharing/share-offsite/?url=https://ainacademy.com', '_blank');
  };
  const shareWhatsApp = () => {
    window.open('https://api.whatsapp.com/send?text=Acabo%20de%20inscribirme%20en%20la%20Certificaci%C3%B3n%20Europea%20de%20IA%20para%20Project%20Managers.%20%C2%A1Te%20la%20recomiendo!', '_blank');
  };
  return <div className="min-h-screen bg-bg text-center" data-id="element-378">
      <div className="bg-gradient-to-br from-dark to-[#1a2744] text-white py-12 px-6 text-center" data-id="element-379">
        <motion.div initial={{
        scale: 0,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 20
      }} className="text-[64px] mb-4" data-id="element-380">
          🎉
        </motion.div>
        <h1 className="text-[32px] font-extrabold mb-2" data-id="element-381">
          ¡Bienvenido/a, {firstName}!
        </h1>
        <p className="text-[17px] opacity-85" data-id="element-382">
          Tu certificación está activada. Revisa tu email ahora.
        </p>
      </div>

      <div className="max-w-[600px] mx-auto py-8 px-5" data-id="element-383">
        <h3 className="text-[20px] font-bold mb-4 text-dark text-left" data-id="element-384">
          📋 Tus próximos pasos:
        </h3>

        <div className="space-y-2.5" data-id="element-385">
          {[{
          n: 1,
          t: '📧 <strong>Revisa tu email</strong> — recibirás tus credenciales en los próximos 5 minutos'
        }, {
          n: 2,
          t: '🎓 <strong>Accede al Módulo 1</strong> — tendrás tu primera automatización funcionando en 60 minutos'
        }, {
          n: 3,
          t: '👥 <strong>Únete a la comunidad</strong> — conecta con 4,700+ Project Managers con IA en LATAM'
        }, {
          n: 4,
          t: '🏅 <strong>Completa el programa</strong> — recibe tu Certificado Europeo Oficial al finalizar'
        }].map((step, i) => <div key={i} className="bg-white rounded-xl py-4 px-4.5 flex gap-3.5 items-center shadow-[0_2px_8px_rgba(0,0,0,0.06)] text-left" data-id="element-386">
              <div className="bg-primary text-white w-8 h-8 rounded-full flex items-center justify-center font-bold shrink-0" data-id="element-387">
                {step.n}
              </div>
              <p className="text-[14px] text-text" dangerouslySetInnerHTML={{
            __html: step.t
          }} data-id="element-388" />
            </div>)}
        </div>

        <button className="bg-primary hover:bg-primary-hover text-white border-none rounded-xl py-4 px-8 text-[17px] font-bold cursor-pointer w-full max-w-[400px] mx-auto block transition-all duration-200 shadow-primary hover:-translate-y-0.5 mt-6" data-id="element-389">
          👉 ACCEDER A MI PROGRAMA AHORA
        </button>
      </div>

      <div className="py-6 px-5 pb-12" data-id="element-390">
        <h3 className="text-[18px] font-bold mb-3.5 text-dark" data-id="element-391">
          🎊 Comparte tu logro:
        </h3>
        <div className="flex gap-2.5 justify-center flex-wrap" data-id="element-392">
          <button onClick={shareLinkedIn} className="bg-[#0077B5] text-white border-none rounded-lg py-3 px-6 text-[14px] font-bold cursor-pointer flex items-center gap-1.5 hover:bg-[#006097] transition-colors" data-id="element-393">
            💼 Compartir en LinkedIn
          </button>
          <button onClick={shareWhatsApp} className="bg-[#25D366] text-white border-none rounded-lg py-3 px-6 text-[14px] font-bold cursor-pointer flex items-center gap-1.5 hover:bg-[#1da851] transition-colors" data-id="element-394">
            📱 Compartir en WhatsApp
          </button>
        </div>
      </div>

      <div className="bg-surface p-5 text-center text-[12px] text-textlight border-t border-border" data-id="element-395">
        © 2026 AIN Academy · Todos los derechos reservados
      </div>
    </div>;
};